import getPoliticians from './getPoliticians'
import getPoliticalOfficesFromCity from './getPoliticalOfficesFromCity'
import getPoliticalPartiesFromCity from './getPoliticalPartiesFromCity'

export default {
  getPoliticians,
  getPoliticalOfficesFromCity,
  getPoliticalPartiesFromCity,
}
